import { render, staticRenderFns } from "./EditTenantBtn.vue?vue&type=template&id=4b512e52&"
import script from "./EditTenantBtn.vue?vue&type=script&lang=js&"
export * from "./EditTenantBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports